import { Trans } from '@lingui/react/macro';
import {
  NoteGenerationLoadingAnimation,
  noteGenerationStepAtom,
} from '@repo/videa-notes';
import { useAtomValue } from 'jotai';

import { SlideOutViewLayout } from '../SlideOutViewLayout';

export const NoteGenerationView = () => {
  const currentStep = useAtomValue(noteGenerationStepAtom);
  return (
    <SlideOutViewLayout bodyClassName="vai-flex vai-items-center vai-justify-center">
      <NoteGenerationLoadingAnimation
        currentStep={currentStep}
        stepLabels={{
          preparing: <Trans>Preparing audio...</Trans>,
          uploading: <Trans>Uploading recording...</Trans>,
          generating: <Trans>Generating your note...</Trans>,
          complete: <Trans>Complete!</Trans>,
        }}
        subtitle={<Trans>AI is analyzing your recording...</Trans>}
        progressLabels={{
          prepare: <Trans>Prepare</Trans>,
          upload: <Trans>Upload</Trans>,
          generate: <Trans>Generate</Trans>,
        }}
      />
    </SlideOutViewLayout>
  );
};
